import { get } from 'lodash';
import { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { CentralProviderContext } from '../centralProviderContext/CentralProviderContext';
import { isFleetLocation, isProviderLocation } from './customers';
export function roleAllowsAction(actionPath, permissions) {
    return !!get(permissions, actionPath);
}
var checkLocationRequired = function (grant) { return grant.grant_location_type !== null; };
export function validatePermissions(customer, actionPath, profile) {
    if (!profile || !profile.grants)
        return false;
    var grantsWithLocation = profile.grants.filter(function (g) {
        var isLocationRequired = checkLocationRequired(g);
        if (!isLocationRequired && !customer)
            return true;
        if (!customer)
            return false;
        if (isProviderLocation(customer) && roleAllowsAction('accounts_manager.manage_all_providers', g.role.permissions)) {
            return true;
        }
        if (isFleetLocation(customer) && roleAllowsAction('accounts_manager.manage_all_fleets', g.role.permissions)) {
            return true;
        }
        var amp = get(g, 'role.permissions.accounts_manager');
        if (!amp) {
            var role = g.role.name.toLocaleLowerCase();
            if (role === 'michelin employee')
                return true;
            if (role === 'michelin administrator')
                return true;
            if (role === 'dsp central administrator')
                return true;
        }
        var locs = [];
        g.locations.forEach(function (lg) { return lg.locations.forEach(function (l) { return l && locs.push(l.toString()); }); });
        if (locs.includes(customer.ship_to_customer))
            return true;
        if (locs.includes(customer.bill_to_customer))
            return true;
        if (customer.home_office_number && locs.includes(customer.home_office_number))
            return true;
        if (customer.parent_company_number && locs.includes(customer.parent_company_number))
            return true;
        return false;
    });
    return grantsWithLocation.some(function (g) { return roleAllowsAction(actionPath, g.role.permissions); });
}
export function usePermissions() {
    var _a;
    var context = useContext(CentralProviderContext);
    var history = useHistory();
    var navigateTo = useCallback(function (path) {
        var _a;
        if (!((_a = context.selectedGrantLocation) === null || _a === void 0 ? void 0 : _a.customer_number) || !path)
            return null;
        if (path[0] !== '/') {
            history.push(path);
        }
        else {
            history.push("/".concat(context.selectedGrantLocation.customer_number).concat(path));
        }
        return null;
    }, [history, context.selectedGrantLocation, (_a = context.selectedGrantLocation) === null || _a === void 0 ? void 0 : _a.customer_number]);
    var allowsAction = useCallback(function (actionPath) { return validatePermissions(context.selectedGrantLocation, actionPath, context.centralProfile); }, [context.selectedGrantLocation, context.centralProfile]);
    return {
        allowsAction: allowsAction,
        profile: context.centralProfile,
        location: context.selectedGrantLocation,
        navigateTo: navigateTo,
    };
}
//# sourceMappingURL=permissions.js.map